module.exports = __webpack_public_path__ + "static/media/mouse-alt.cb403768.svg";